module.exports = __webpack_public_path__ + "img/heart.2662d324.svg";